import * as React from 'react';
import classNames from 'classnames';

import type { WithChildren } from 'common/types';

import styles from './styles.module.scss';

interface IFormWrapperProps {
  header: string;
  description?: string,
  buttonsBlock?: React.ReactNode
  className?: string;
  overrideStyles?: Partial<typeof styles>;
}

/**
 * Form wrapper to wrap default styles for each view
 */
const FormWrapper = ({
  children,
  header,
  description,
  className,
  overrideStyles,
}: WithChildren<IFormWrapperProps>) => (
  <div className={classNames(styles.wrapper, 'common-components-FormWrapper__wrapper', overrideStyles?.wrapper, className)}>
    <div className={classNames(styles.form, 'common-components-FormWrapper__form', overrideStyles?.form)}>
      <div className={classNames(styles.content, 'common-components-FormWrapper__content', overrideStyles?.content)}>
        <h1 className={classNames(styles.title, 'common-components-FormWrapper__title', overrideStyles?.title)}>{header}</h1>
        {description && (
          <p
            className={classNames(styles.description, 'common-components-FormWrapper__description', overrideStyles?.description)}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
        {
          React.Children.map(children, (child, index) => {
            if (React.Children.count(children) - 1 !== index) {
              return child;
            }
            return null;
          })
        }
      </div>
      {React.Children.count(children) > 1 && React.Children.toArray(children)[React.Children.count(children) - 1]}
    </div>
  </div>
);

export default FormWrapper;
